import { Component } from '@angular/core';
import { LernformService } from '../../../services/facetten/instance/lernformen-facetten/lernform.service';
import { LernformFacettenService } from '../../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';
import { UnterrichtsformBasisFacetteComponent } from './unterrichtsform-basis-facette/unterrichtsform-basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-unterrichtsform-facette',
  templateUrl: './unterrichtsform-facette.component.html',
  imports: [UnterrichtsformBasisFacetteComponent],
  providers: [
    // Hier wird der LernformFacettenService injected, welcher dann in der UnterrichtsFormBasisFacette verwendet werden kann
    { provide: LernformFacettenService, useExisting: LernformService }
  ]
})
export class UnterrichtsformFacetteComponent {}
